import api from './api';

export const zoneService = {
  // Get all active zones (public)
  getAllZones: async () => {
    const response = await api.get('/zones');
    return response.data;
  },

  // Get single zone with products (public)
  getZone: async (id) => {
    const response = await api.get(`/zones/${id}`);
    return response.data;
  },

  // Get all zones including inactive (admin)
  getAllZonesAdmin: async () => {
    const response = await api.get('/zones/admin/all');
    return response.data;
  },

  // Create zone (admin)
  createZone: async (zoneData) => {
    const response = await api.post('/zones', zoneData);
    return response.data;
  },

  // Update zone (admin)
  updateZone: async (id, zoneData) => {
    const response = await api.put(`/zones/${id}`, zoneData);
    return response.data;
  },

  // Delete zone (admin)
  deleteZone: async (id) => {
    const response = await api.delete(`/zones/${id}`);
    return response.data;
  },
};

export default zoneService;

